export const DISPLAY_DURATION = 4000;

export const SELECTORS = {
  CLOSE: 'js-global-snackbar-close',
  CONTAINER: 'js-global-snackbar',
  MESSAGE: 'js-global-snackbar-message',
  STATUS: 'js-global-snackbar-status'
};

export const CLASS_NAMES = {
  SEGMENT: 'global-snackbar__segment',
  SEGMENT_EMPHASIZED: 'global-snackbar__segment--emphasized',
  VISIBLE: 'global-snackbar--visible'
};
